import React from "react";
import cn from "../../../lib/cn";
import P from "../../../shared/typography/P";
import PaymentStatus from "./PaymentStatus";

const PaymentCard = ({
    heading,
    status,
    due,
    paid,
    statusType,
    className,
    isSelected,
    showCircle = true,
}) => {
    return (
        <div
            className={cn(
                "p-1.5 flex gap-1 items-center rounded-2 w-full border shadow-md",
                className
            )}
        >
            {showCircle && (
                <div className="h-3 w-3 rounded-full bg-gray-60 flex items-center justify-center">
                    <div
                        className={cn("h-1.5 w-1.5 rounded-full bg-gray-50", {
                            "bg-blue-100": isSelected,
                        })}
                    />
                </div>
            )}
            <div className="flex-1">
                <div className="flex items-center justify-between">
                    <P className="font-vietnam xlg:text-sm 2xl:text-sm lg:font-urbanist">
                        {heading}
                    </P>
                    <div>
                        <div>
                            <PaymentStatus
                                status={status}
                                statusType={statusType}
                            />
                        </div>
                    </div>
                </div>
                <div className="flex items-center justify-between py-1">
                    <P className="!text-xs text-gray-370 font-vietnam  lg:font-urbanist">
                        Amount due
                    </P>
                    <P className="!text-sm font-vietnam lg:font-urbanist">
                        ₹ {due}
                    </P>
                </div>
                <div className="flex items-center justify-between">
                    <P className="!text-xs text-gray-370 font-vietnam  lg:font-urbanist">
                        Amount Paid
                    </P>
                    <P className="!text-sm font-vietnam  lg:font-urbanist">
                        ₹ {paid}
                    </P>
                </div>
            </div>
        </div>
    );
};

export default PaymentCard;
